import React, { useState, useEffect, } from "react";
import config from "config";
import Spinner from "NOTICEBOARD/CommonResources/SpinnerLoader/Spinner";
import NoticeboardAPICall from "NoticeboardAPICall";
import { BarChart, CalendarTodayOutlined, Close, FilterAltOutlined, KeyboardArrowDownOutlined, Refresh } from '@mui/icons-material';
import 'NOTICEBOARD/Components/Notices/Notices.css'
import NoticeViewGraph from 'NOTICEBOARD/Components/Notices/Charts/NoticeViewGraph';
import PostNotice from 'NOTICEBOARD/Components/PostNotice/PostNotice';
import { AssigneeChart } from './Charts/AssigneeChart';
import { ViewsChart } from './Charts/ViewsChart';
import PercentageView from './Charts/PercentageView';
import NoticeView from './NoticeView/NoticeView';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import Assignees from "./Assignees/Assignees";
import DeleteModal from 'NOTICEBOARD/CommonResources/DeleteModal/DeleteModal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonLoader from "NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader";
import Popover from '@mui/material/Popover';
import {Timeline, TimelineEvent} from 'react-event-timeline';


const Notices = (props) => {

    // api path
    let apiPathGetNoticeList = '/api/notice/notice.php';
    let apiPathDeleteNotice = '/api/notice/notice.php';
    let apiPathGetIndividualNoticeDetails = '/api/notice/notice.php';
    // css styling
    let styles = {
        iconStyle: {
            color: '#828282',
            fontSize: '20px',
            marginRight: "5px",
        },

        dotIconStyle: {
            color: '#BDBDBD',
            fontSize: '10px',
            marginLeft: '5px'
        },

        bookmarkChecked: {
            color: '#FF9900'
        },

        bookmarkUnchecked: {
            color: '#828282',
        },

        bookMarkStatusCheck: {
            color: '#FF9900'
        },

        bookMarkStatusUncheck: {
            color: '#828282'
        },

        unreadNoticeUnchecked: {
            color: '#828282',
        },

        unreadNoticeChecked: {
            color: '#0465AC'
        },

        buttonDivStyle: {
            color: '#828282',
            fontSize: '12px',
            marginRight: '5px',
            padding: '5px',
            textAlign: 'center',
            background: 'white',
            cursor: 'pointer',
        },

        activeButtonDivStyle: {
            color: 'white',
            backgroundColor: '#0465AC',
            fontSize: '12px',
            marginRight: '5px',
            padding: '5px',
            textAlign: 'center',
            cursor: 'pointer',
        },

        popoverTextTitle: {
            width: '32%',
            borderRadius: '5px',
            padding: '2px',
            fontSize: 'small',
            color: 'rgba(0, 0, 0, 0.8)',
        },

        popoverInput: {
            border: '1px solid rgba(4, 101, 172, 0.7)',
            padding: '2px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.4)',
        }
    }

    //popover for select category
    const [datePopover, setDatePopover] = React.useState(null);
    const [categoryPopover, setCategoryPopover] = React.useState(null);

    const open = Boolean(datePopover);
    const openCategory = Boolean(categoryPopover);

    const idSearchByDate = open ? 'simple-popover' : undefined;
    const idCategory = openCategory ? 'simple-popover' : undefined;

    // states for getting data    
    const [noticeList, setNoticeList] = useState({});
    const [noticeSequence, setNoticeSequence] = useState([]);
    const [noticeTitle, setNoticeTitle] = useState('');
    const [filterTitle, setFilterTitle] = useState('');
    const [filterToDate, setFilterToDate] = useState('');
    const [filterFromDate, setFilterFromDate] = useState('');
    const [categoryFetching, setCategoryFetching] = useState(false);
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [categoryList, setCategoryList] = useState({});
    const [isCategorySelected, setIsCategorySelected] = useState(false);
    const [searchCategory, setSearchCategory] = useState('');
    const [filterCategory, setFilterCategory] = useState('');
    const [getIndividualNoticeDetails, setGetIndividualNoticeDetails] = useState({});
    const [fetchingIndividualNotice, setFetchingIndividualNotice] = useState(false);
    const [readHistoryNoticeList, setReadHistoryNoticeList] = useState({});
    const [getNoticeAnalytics, setGetNoticeAnalytics] = useState({});
    const [notificationHistory, setNotificationHistory] = useState({});
    const [clearFilter, setClearFilter] = useState(false);

    // states for spinners
    const [dataFetching, setDataFetching] = useState(false);
    const [fetchingReadHistory, setFetchingReadHistory] = useState(false);
    const [fetchingNoticeAnalytics, setFetchingNoticeAnalytics] = useState(false);
    const [fetchingNotificationHistory, setFetchingNotificationHistory] = useState(false);

    const [showAnalyticsModal, setShowAnalyticsModal] = useState(false);
    const [dataFetchingRemoveNotice, setDataFetchingRemoveNotice] = useState(false);
    const [dataFetchingNoticeListReadHistory, setDataFetchingNoticeListReadHistory] = useState(false);

    const [noticeTitleStateForAssignee, setNoticeTitleStateForAssignee] = useState('');
    const [noticeIdStateForAssignee, setNoticeIdStateForAssignee] = useState('');

    // states for modal , sidebar and table
    const [selectedArray, setSelectedArray] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [showSideBarNoticeView, setShowSideBarNoticeView] = useState(false);
    const [showSideBarAssignees, setShowSideBarAssignees] = useState(false);
    const [showSideBarPostNotice, setShowSideBarPostNotice] = useState(false);
    const [showModalFilter, setShowModalFilter] = useState(false);
    const [clickedNoticeId, setClickedNoticeId] = useState('1');
    const [readHistoryTitle, setReadHistoryTitle] = useState('');

    const [sendingNotification, setSendingNotification] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [responseMessageType, setResponseMessageType] = useState('');

    // state for delete data permanently
    const [deleteModalDetails, setDeleteModalDetails] = useState({
        deleteModal: false,
        deleteModalText: '',
        deleteErrorVisibility: false
    });

    // STATES AND METHODS FOR PAGINATION
    const [totalCount, setTotalCount] = useState(0);
    const [pagination, setPagination] = useState({
        pageIndex: 1,
        limit: 10,
        offset: 0
    });

    // METHOD FOR USER PAGINATION COUNT
    const updatePaginationCount = (pageNumber) => {
        setPagination({
            offset: ((pageNumber - 1) * pagination.limit),
            pageIndex: pageNumber,
            limit: pagination.limit
        });
    }

    // STATE FOR SUCCESS MODAL DETAILS
    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });

    // CODE FOR READ HISTORY
    const [readHistoryFilter, setReadHistoryFilter] = useState({
        notice_id: "",
        role: "",
        date: "",
    });

    // METHOD FOR READ HISTORY FILTER 
    const readHistoryFilterBy = () => {
        getNoticeAssigneeListReadHistory();
        setShowModalFilter(false);
    }

    // METHOD FOR CLOSE READ HISTORY MODAL 
    const closeFilterModal = () => {
        setShowModalFilter(false);
        setReadHistoryFilter({
            notice_id: "",
            role: "",
            date: "",
        });
        getNoticeAssigneeListClearReadHistory();
    }

    // HOOKS FOR GET CLEAR NOTICE ANALYTICS API CALL
    useEffect(() => {
        getNoticeAssigneeListClearReadHistory();
    }, []);

    // HOOKS FOR GET NOTICE ANALYTICS API CALL
    useEffect(() => {
        if(readHistoryFilter.notice_id != '') {
            getGetNoticeAnalytics();
        }
    }, [readHistoryFilter.notice_id]);

    // HOOKS FOR GET NOTICE LIST API CALL
    useEffect(() => {
        getNoticeList();
    }, [pagination, props.isNewNoticeAdded]);
    
    // calling CategoryListAPI to get category
    useEffect(() => {
        getCategoryListAPICall();
    }, [searchCategory]);

    useEffect(() => {
        if (clearFilter) 
        {
            getNoticeList();
            setClearFilter(false); // Reset clearFilter to false after it's been used
        }
    }, [clearFilter]);

    // METHOD FOR GET NOTICE ASSIGNEE LIST FOR READ HISTORY API CALL
    const getNoticeAssigneeListReadHistory = async () => {
        setFetchingReadHistory(true);

        let formData = {
            institute_id: config.institute_id,
            notice_id: readHistoryFilter.notice_id,
            page_index: 1,
            limit: 10,
            filter_role: readHistoryFilter.role,
            filter_date: readHistoryFilter.date,
            filter_department: "",
            filter_group: "",
            filter_academic_year: "",
            view_read_history: true
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getNoticeAssigneeList",
            formData,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getNoticeAssigneeListReadHistory();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setReadHistoryNoticeList(apiResult);
                setFetchingReadHistory(false);
            } else {
                setFetchingReadHistory(false);
            }
        }
    }

    // METHOD FOR GET NOTICE ASSIGNEE LIST FOR CLEAR READ HISTORY API CALL
    const getNoticeAssigneeListClearReadHistory = async () => {
        setFetchingReadHistory(true);

        let formData1 = {
            institute_id: config.institute_id,
            notice_id: readHistoryFilter.notice_id,
            page_index: 1,
            limit: 10,
            filter_role: '',
            filter_department: "",
            filter_group: "",
            filter_academic_year: "",
            view_read_history: true
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getNoticeAssigneeList",
            formData1,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getNoticeAssigneeListReadHistory();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setReadHistoryNoticeList(apiResult);
                setFetchingReadHistory(false);
            } else {
                setFetchingReadHistory(false);
            }
        }
    }

    // METHOD FOR GET NOTICE ANALYTICS FOR ANALYTICS API CALL
    const getGetNoticeAnalytics = async () => {
        setFetchingNoticeAnalytics(true);
        setClearFilter(false)

        let formData = {
            institute_id: config.institute_id,
            notice_id: readHistoryFilter.notice_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getNoticeAnalytics",
            formData,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getGetNoticeAnalytics();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                setGetNoticeAnalytics(apiResult);
                setFetchingNoticeAnalytics(false);
            } else {
                setFetchingNoticeAnalytics(false);
            }
        }
    }

    // METHOD FOR GET NOTICE LIST API CALL
    const getNoticeList = async () => {
        setDataFetching(true);
        let formData = {
            institute_id: config.institute_id,
            user_id: config.faculty_id,
            page_index: pagination.pageIndex,
            limit: pagination.limit,
            filter_title: filterTitle,
            filter_category: filterCategory,
            filter_from_date: filterFromDate,
            filter_to_date: filterToDate,
            filter_unread: '',
            filter_bookmark: '',
            filter_day_type: '',
            filter_posted_by_id_array: [config.faculty_id],
            user_role: '',
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getNoticeList",
            formData,
            apiPathGetNoticeList
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                getNoticeList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                var sortedIdArray = jsonResponse.APIResult.sequenceIdArray;

                setNoticeList(apiResult);
                setNoticeSequence(sortedIdArray);
                setTotalCount(jsonResponse.APIResult.totalCount);
                setDataFetching(false);
            } else {
                setDataFetching(false);
            }
        }
    };

    // METHOD TO GET CATEGORY LIST API CALL    
    const getCategoryListAPICall = async () => {
        setCategoryFetching(true);

        let formData = {
            "iid": config.institute_id,
            "offset": '',
            "limit": '',
            "filterCategoryName": searchCategory,
            "filterStatus": ""
        }
        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'GetNoticeBoardCategoryList',
            formData,
            '/api/notice/category.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getCategoryListAPICall();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setCategoryList(apiResult);
                setCategoryFetching(false);
            } else {
                setCategoryFetching(false);
            }
        }

    }

    // FUNCTION FOR DELETE NOTICES API CALL
    const deleteNotice = async () => {
        setDeleteModalDetails({
            DeleteModal: false,
            deleteModalText: '',
            deleteErrorVisibility: false,
        });

        let formData = {
            institute_id: config.institute_id,
            notice_id_array: selectedArray,
            added_by: config.faculty_id,

        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "deleteNotice",
            formData,
            apiPathDeleteNotice
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getNoticeList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status === 'success') {
                    let noticeListDeleted = noticeList;
                    let noticeSequenceArray = noticeSequence;
                    if(totalCount <= (pagination.pageIndex * pagination.limit)) {
                        selectedArray.map(id => {
                            delete noticeListDeleted[id];
                            noticeSequenceArray = noticeSequenceArray.filter(noticeId => noticeId != id);
                        });
    
                        setNoticeSequence([ ...noticeSequenceArray ]);
                        setNoticeList({ ...noticeListDeleted });
                    }else {
                        getNoticeList();
                    }

                    setSelectedArray([]);
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: "success",
                        successMessage: apiResult.message,
                    });
                } else if (apiResult.status === 'fail') {
                    setDeleteModalDetails({
                        DeleteModal: false,
                    });

                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: "warning",
                        successMessage: apiResult.message,
                    });
                }
            } else {
                setDeleteModalDetails({
                    DeleteModal: false,
                });

                setSuccessModalDetails({
                    successModal: true,
                    successModalType: "error",
                    successMessage: "Something went wrong while getting category list. Please try again later."
                });
            }
        }
    }

    // FUNCTION FOR GET INDIVIDUAL NOTICE DETAILS API CALL
    const apiCallToGetIndividualNotice = async (noticeId) => {
        setFetchingIndividualNotice(true);

        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.faculty_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getIndividualNoticeDetails",
            formData,
            apiPathGetIndividualNoticeDetails
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetIndividualNotice(noticeId);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setFetchingIndividualNotice(false);
                setGetIndividualNoticeDetails(apiResult);
            } else {
                setFetchingIndividualNotice(false);
            }
        }
    }

    // METHOD TO DELETE CATEGORY MODAL
    const getDeleteCategoryDetails = () => {
        setDeleteModalDetails({
            deleteModal: true,
        });
    }


    // METHOD FOR SHOW NOTIFICATION LIST
    const apiCallToGetNotificationDetails = async () => {
        setFetchingNotificationHistory(true);
       let formData = {
            iid: config.institute_id,
            noticeId: readHistoryFilter.notice_id,
            pageIndex: 1,
            limit: 1000,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetNoticeNotificationHistory",
            formData,
            '/api/notice/notice.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetNotificationDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setFetchingNotificationHistory(false);
                setNotificationHistory(apiResult);
            } else {
                setFetchingNotificationHistory(false);
            }
        }
    }
    // METHOD FOR CLOSE DELETE MODAL
    const closeDeleteModal = () => {
        setDeleteModalDetails({
            DeleteModal: false,
            deleteModalText: '',
            deleteErrorVisibility: false,
        });
    }

    // STATE FOR UPDATE NOTICE DATA
    const [updateData, setUpdateData] = useState({
        "institute_id": '',
        "unique_id": "",
        "title": "",
        "description": "",
        "category_id": "",
        "last_category_id" : "",
        "department_array": "",
        "institute_department_array": "",
        "date": "",
        "aca_yr": "",
        "display_on_website": "",
        "posted_by": "",
    });

    // METHOD TO GET UPDATE NOTICE DATA
    const updateNotice = () => {
        if (selectedArray.length === 1) {
            setEditMode(true);
            setShowSideBarPostNotice(true);
            setUpdateData({
                "institute_id": '',
                "noticeId": noticeList[selectedArray.toString()].noticeId,
                "title": noticeList[selectedArray.toString()].title,
                "description": noticeList[selectedArray.toString()].description,
                "categoryId": noticeList[selectedArray.toString()].categoryId,
                "last_category_id" : noticeList[selectedArray.toString()].categoryId,
                "categoryName": noticeList[selectedArray.toString()].categoryName,
                "department_array": noticeList[selectedArray.toString()].departmentIdArray,
                "institute_department_array": noticeList[selectedArray.toString()].instituteDepartmentArray,
                "noticeDate": noticeList[selectedArray.toString()].noticeDate,
                "formattedNoticeDate": noticeList[selectedArray.toString()].formattedNoticeDate,
                "academicYear": noticeList[selectedArray.toString()].academicYear,
                "department": noticeList[selectedArray.toString()].department,
                "academicYearId": noticeList[selectedArray.toString()].academicYearId,
                "display_on_website": noticeList[selectedArray.toString()].displayOnWebsite,
                "posted_by": "",
                "attachment": noticeList[selectedArray.toString()].attachment,
                "attachmentPath": noticeList[selectedArray.toString()].attachmentPath
            });
        } else {
            setSuccessModalDetails({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'Please select only one notice to update.'
            });
        }
    }

    // FUNCTION FOR SELECT ALL NOTICES
    const selectAllNotices = (e) => {
        let temp = new Set();
        if (e.target.checked) {
            Object.keys(noticeList).map(noticeId => {
            let notice = noticeList[noticeId];
                if (notice.status !== 'Approved') 
                {
                    temp.add(noticeId);
                }
            });

            setSelectedArray(Array.from(temp));
        } else {
            Object.keys(noticeList).map(noticeId => {
                temp.delete(noticeId);
            });
        }


        setSelectedArray(Array.from(temp));
    }

    // METHOD TO ADD AND REMOVE FROM SELECTED ARRAY
    const addAndRemoveFromSelectedArray = (e, id) => {
        let selectedArrayTemp = selectedArray;
        if (selectedArrayTemp.includes(id.toString())) {
            selectedArrayTemp = selectedArrayTemp.filter(arrayId => arrayId != id);
        } else {
            selectedArrayTemp.push(id.toString());
        }

        setSelectedArray([...selectedArrayTemp]);
    }

    // METHOD FOR SEARCH READ HISTORY TITLE  
    const enterToSearchReadHistoryByTitle = (e) => {
        setReadHistoryFilter({
            searchReadHistoryTitle: readHistoryTitle,
            notice_id: readHistoryFilter.notice_id,
            role: readHistoryFilter.role,
            date: readHistoryFilter.date,
        });
        getNoticeAssigneeListReadHistory();
    }

    // METHOD FOR SET SHOW RESULT
    const setShowResult = (e) => {
        setPagination({
            pageIndex: 1,
            limit: e.target.value,
            offset: 0
        });
    }

    // CUSTOM TABS FOR ANALYTICS AND READ HISTORY
    const [tabs,] = useState(['Analytics', 'Read History', 'Notification']);
    const [activeTab, setActiveTab] = useState('Analytics');

    // METHOD TO RETURN CUSTOM TABS
    const CustomTabs = () => {
        return (
            <div>
                <div className='d-flex customTabDiv' style={ { gap: '20px', } }>
                    {
                        tabs.map((tabName) => {
                            return (
                                <div 
                                    className={ 
                                        activeTab === tabName 
                                        ? 'text-primary customTabDiv__button ' 
                                        : 'text-center' 
                                    } 
                                    onClick={ () => 
                                        tabName == "Analytics" 
                                        ? (setActiveTab(tabName), getGetNoticeAnalytics()) 
                                        : tabName == "Read History" 
                                        ? (setActiveTab(tabName), getNoticeAssigneeListReadHistory()) 
                                        : tabName == "Notification"  
                                        && (setActiveTab(tabName), apiCallToGetNotificationDetails()) 
                                    }
                                >
                                    { tabName }
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    // API CALL METHOD TO SEND NOTIFICATION
    const apiCallToSendNotification = async () => {
        setSendingNotification(true);
        let requestData = {
            "iid": config.institute_id,
            "noticeId": readHistoryFilter.notice_id,
            "noticeSentBy": config.faculty_id
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "sendNoticeAppNotification",
            requestData,
            '/api/notice/notice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToSendNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    setResponseMessage(apiResult.message);
                    setResponseMessageType('success');
                    setSendingNotification(false);
                    apiCallToGetNotificationDetails();
                }else {
                    setResponseMessage(apiResult.message);
                    setResponseMessageType('warning');
                    setSendingNotification(false);
                }
            } else {
                setResponseMessage('Something went wrong while sending notification. Please try again later.');
                setResponseMessageType('error');
                setSendingNotification(false);
            }
        }
        
    }
    
    // METHOD TO OPEN SELECT DATE POPOVER
    const selectDate = (event) => {
        setDatePopover(event.currentTarget);
    };

    // METHOD TO CLOSE SELECT DATE POPOVER
    const closeSelectDate = () => {
        setDatePopover(null);
    };

    // METHOD TO OPEN SELECT CATEGORY POPOVER
    const selectCategory = (event) => {
        setCategoryPopover(event.currentTarget);
    };

    // METHOD FOR CLOSE SEARCH CATEGORY POPOVER
    const closeSelectCategory = () => {
        setFilterCategory('');
        setSearchCategory('');
        setCategoryPopover(null);
        setNoticeList({});
        setNoticeSequence([]);
        setPagination({
            pageIndex: 1,
            limit: 10,
            offset: 0
        });
    };

    // METHOD TO SEARCH BY DATE
    const searchByDate = () => {
        if (filterFromDate && filterToDate) {
            setIsDateSelected(true);
            closeSelectDate();
            setNoticeList({});
            setNoticeSequence([]);
            setPagination({
                pageIndex: 1,
                limit: 10,
                offset: 0
            });
        }
        else {
            setIsDateSelected(false);
        }
    }
    const closeFilter = () => {
        setFilterToDate('');
        closeSelectDate();
        setFilterFromDate('');
        setPagination({
            pageIndex: 1,
            limit: 10,
            offset: 0
        });
        setIsDateSelected(false);
    }

    // METHOD TO SEARCH BY Category
    const searchByCategory = () => {
        if (filterCategory) {
            setIsCategorySelected(true);
            setNoticeList({});
            setNoticeSequence([]);
            setPagination({
                pageIndex: 1,
                limit: 10,
                offset: 0
            });
            setCategoryPopover(null);
        }
        else {
            setIsCategorySelected(false);
        }
    }

    // METHOD TO GET MESSAGE FROM POST NOTICE
    const getMessage = (message) => {
        setSuccessModalDetails({
            successModal: true,
            successModalType: 'success',
            successMessage: message
        });
        setSelectedArray([]);
    }

    // METHOD TO CLOSE WARNING MODAL
    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        });
    }

    return (
        <>
            <Popover
                id={ idSearchByDate }
                open={ open }
                anchorEl={ datePopover }
                onClose={() => closeSelectDate}
                anchorOrigin={ {
                    vertical: 'bottom',
                    horizontal: 'left',
                } }
            >
                <div className='p-2' style={ { height: '80px', width: '480px' } }>
                    <div className="row">
                        <div style={ styles.popoverTextTitle }>From</div>
                        <div style={ styles.popoverTextTitle }>To</div>
                        <div style={ styles.popoverTextTitle }></div>
                        <div style={ styles.popoverTextTitle }>
                            <input
                                value={ filterFromDate }
                                onChange={(e) => setFilterFromDate(e.target.value)}
                                type="date"
                                style={ styles.popoverInput }
                                className='w-100 rounded' 
                            />
                        </div>
                        <div style={ styles.popoverTextTitle }>
                            <input
                                value={ filterToDate }
                                min={filterFromDate}
                                onChange={(e) => setFilterToDate(e.target.value)}
                                type="date" 
                                style={ styles.popoverInput } 
                                className='w-100 rounded' 
                            />
                        </div>
                        <div>
                            <button
                                onClick={ () => searchByDate() }
                                type="button"
                                className="my-0 smallNormalFont py-1 shadow-none btn btn-primary"
                            >
                                Apply
                            </button>
                            <button
                                onClick={ () => closeFilter() }
                                type="button"
                                className="my-0 smallNormalFont py-1 shadow-none btn btn-outline-primary"
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </Popover>

            {/* popover for category */ }
            <Popover
                id={ idCategory }
                open={ openCategory }
                anchorEl={ categoryPopover }
                anchorOrigin={ {
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div className='p-2' style={ { height: '190px', maxWidth: '500px' } } >
                    <div className='scrollController' style={ { height: '80%' } }>
                        <div className='row'><div className='col-12'>
                            <input className='w-100 searchCategoryInput '
                                placeholder='Search category...'
                                value={ searchCategory }
                                onKeyPress={ e => {
                                    if (e.charCode === 13) {
                                        setSearchCategory(e.target.value);
                                    }
                                } }
                                onChange={ (e) => setSearchCategory(e.target.value) } 
                            />
                        </div></div>
                        <div className='row col-md-12' style={ { fontSize: '13px' } }>
                            {
                                Object.keys(categoryList).length > 0 ?
                                    Object.keys(categoryList).map(categoryId => {
                                        return (
                                            <div className='col-6 form-check text-left my-1 categoryFilter-name' title={categoryList[categoryId].title} key={ categoryId }>
                                                <input
                                                    onChange={ () => setFilterCategory(categoryId) }
                                                    className="form-check-input"
                                                    name="flexRadioDefault"
                                                    type="radio"
                                                    id="flexCheckDefault"
                                                    checked={ categoryId == filterCategory ? true : false }
                                                />
                                                <span className='smallFont secondaryColor'>{ categoryList[categoryId].title }</span>
                                            </div>
                                        );
                                    })
                                :
                                    <p>No category details found.</p>
                            }
                        </div>
                    </div>
                    <div className="d-flex justify-content-end " style={ { height: '20%' } }>
                        <button
                            onClick={ () => searchByCategory() }
                            type="button" className="py-1 my-1 smallFont  shadow-none btn btn-primary">Apply</button>
                        <button type="button" onClick={() => closeSelectCategory()} className="py-1 my-1 smallFont btn shadow-none border border-primary text-primary">Clear</button>
                    </div>
                </div>
            </Popover>
            <div className='px-2'>
                <div className="postNoticeFilter">
                    <div className='mt-2 postNoticeFilterDetails'>
                        <div className="col-md-8 noticeFilterValues" style={{ paddingLeft: 0 }}>
                            <div className='filterValues'>
                                <div className="searchTitle">
                                    <input
                                        type="text"
                                        className="form-control filterNoticeInput"
                                        placeholder="Search by title..."
                                        value={filterTitle}
                                        onChange={(e) => setFilterTitle(e.target.value)}
                                        onKeyUp={(e) => e.key == 'Enter' && getNoticeList()}
                                    />
                                </div>
                                <div className='p-0 py-2'>
                                    <div onClick={(e) => selectDate(e)} className='pointer p-1' style={{ fontSize: 'small', color: '#828282' }}>Select Date<CalendarTodayOutlined className='iconStyle mx-2' /></div>
                                </div>
                                <div onClick={(e) => selectCategory(e)} className='p-0 ml-1'>
                                    <div className='searchCategory pointer' style={{ fontSize: 'small', color: '#828282' }}>
                                        <div>Search By Category</div>
                                        <KeyboardArrowDownOutlined className='mx-1' />
                                    </div>
                                </div>
                                <div 
                                    onClick={e => {
                                        setFilterTitle('');
                                        setFilterFromDate('');
                                        setFilterToDate('');
                                        setFilterCategory('');
                                        setClearFilter(true)
                                    }}
                                    className='pointer p-1' style={{ fontSize: 'small', color: '#0465AC', textDecoration: 'underline'}}
                                >Clear filter</div>
                            </div>
                            <p style={{ fontSize: 'small', color: '#828282' }}>Press enter to search.</p>
                        </div>
                        <div className='d-flex align-items-center' style={{ paddingRight: 0 }}>
                            <div className='smallFont secondaryColor mx-2'>Show Results</div>
                            <div className=''>
                                <select
                                    className="form-select postNoticeInput rounded"
                                    aria-label="Default select example"
                                    value={ pagination.limit }
                                    onChange={ (e) => setShowResult(e) }
                                    style={ { border: '1px solid gray', outline: 'none' } }
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="40">40</option>
                                    <option value="100">100</option>
                                    <option value="250">250</option>
                                </select>
                            </div>
                            &nbsp;&nbsp;
                            <div 
                                className='mr-2'
                                style={{ fontSize: 'smaller' }}
                            >
                                Total records: {totalCount}				
                            </div>
                        </div>
                    </div>
                </div>
                <div className=''>
                    {
                        dataFetching ?
                            <Spinner />
                        :
                            <div className="table-responsive">
                                <table className=" table table-sm table-bordered">
                                    <thead>
                                        <tr className='smallFont'>
                                            <th style={ { padding: 5 } }>
                                                <div>
                                                    <input
                                                        checked={  selectedArray.length > 0 }
                                                        onChange={ (e) => selectAllNotices(e) }
                                                        type="checkbox" 

                                                    />
                                                </div>
                                            </th>
                                            <th style={ { padding: 5 } }>Sr. No.</th>
                                            <th style={ { padding: 5 } }>Notice Title</th>
                                            <th style={ { padding: 5 } }>Notice Id</th>
                                            <th style={ { padding: 5 } }>Category</th>
                                            <th style={ { padding: 5 } }>Departments</th>
                                            <th style={ { padding: 5 } }>Assigned To</th>
                                            <th style={ { padding: 5 } }>Notice Date</th>
                                            <th style={ { padding: 5 } }>Posted On</th>
                                            <th style={ { padding: 5 } }>Analytics</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            selectedArray.length > 0 &&
                                            <tr>
                                                <th style={ { padding: 5 } } colSpan="8" className='py-2 actionButtonsBelt'>
                                                    <span className="actionButtonsBelt_Button" onClick={ () => updateNotice() } >
                                                        Update
                                                    </span>
                                                    <span onClick={ () => getDeleteCategoryDetails() } className='actionButtonsBelt_Button'>
                                                        Delete
                                                    </span>
                                                </th>
                                            </tr>
                                        }
                                        {
                                            noticeSequence.length > 0 ?
                                                noticeSequence.map((noticeId, noticeIndex) => {
                                                    let notice = noticeList[noticeId];
                                                    if(notice)
                                                    {
                                                        return (
                                                            <tr className='newTr'>
                                                                <td style={ { padding: 4 } }>
                                                                    <div className="form-check">
                                                                        <input
                                                                            onChange={ (e) => addAndRemoveFromSelectedArray(e, notice.noticeId) }
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="flexCheckDefault"
                                                                            checked={ selectedArray.includes(notice.noticeId.toString()) }
                                                                            disabled = {notice.status == 'Approved'}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td style={ { padding: 4 } }>{ pagination.offset + noticeIndex + 1 }</td>
                                                                <td style={ { padding: 4 } } onClick={ () => { setShowSideBarNoticeView(true); apiCallToGetIndividualNotice(notice.noticeId); } }>
                                                                    <div className='primaryColor capitalizeWord text-truncate pointer' title={ notice.title } style={ { width: '200px' } }>{ notice.title }</div>
                                                                </td>
                                                                <td style={ { padding: 4 } }> { notice.categorySeries?.length > 0 && `${notice.categorySeries}-${notice.categoryNumber}` } </td>
                                                                <td style={ { padding: 4 } }>
                                                                    <div className='text-truncate' title={ notice.categoryName } style={ { width: '200px' } }>{ notice.categoryName }</div>    
                                                                </td>
                                                                <td title={notice.department} style={ { padding: 4 } }><div className=' text-truncate' style={ { width: '200px' } }>{ notice.department }</div></td>
                                                                <td style={ { padding: 4 } } onClick={ () => { setShowSideBarAssignees(true); setNoticeTitleStateForAssignee(notice.title); setNoticeIdStateForAssignee(notice.noticeId); setClickedNoticeId(notice.noticeId); } } className='primaryColor pointer'> { notice.assigneeCount }</td>
                                                                <td style={ { padding: 4 } }>{ notice.addedOn }</td>
                                                                <td style={ { padding: 4 } }>{ notice.formattedNoticeDate }</td>
                                                                <td style={ { padding: 4 } }><BarChart className='primaryColor' style={ { cursor: 'pointer' } } onClick={ () => { setShowAnalyticsModal(true); setReadHistoryFilter(prev => ({ ...prev, notice_id: notice.noticeId }))} } /></td>
                                                            </tr>
                                                        );
                                                    }
                                                })
                                            :
                                                <tr>
                                                    <td colSpan="10">No notice yet posted.</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                    }
                    {/* component for pagination */ }
                    {
                        !dataFetching && Object.keys(noticeList)?.length > 0 &&
                            <div className="paginationContainer mb-5">
                                <Pagination
                                    activePage={ pagination.pageIndex }
                                    itemsCountPerPage={ pagination.limit }
                                    totalItemsCount={ totalCount }
                                    pageRangeDisplayed={ 3 }
                                    onChange={ (num) => updatePaginationCount(num) }
                                />
                            </div>
                    }
                </div>

                {/* modal for analytics */ }
                {
                    showAnalyticsModal &&
                        <div>
                            <div className="modal fade show" id="modalContainer" >
                                <div className="modal-dialog modal-dialog-centered modal-xl h-75" >
                                    <div className="h-100 modal-content">
                                        <div className="modal-header d-flex text-center p-2" style={ { backgroundColor: '#0465ac' } } >
                                            <div className=" flex-grow-1">
                                                <h5 className="modal-title text-white">Analytics</h5>
                                            </div>
                                            <div className="">
                                                <Close style={ { color: 'white', cursor: 'pointer' } } onClick={ () => { setShowAnalyticsModal(false); setActiveTab('Analytics'); } } />
                                            </div>
                                        </div>
                                        <div className="h-100 bodyBackgroundColor scrollController" style={ { overflow: 'auto' } }>
                                            <div className='row' >
                                                <div className='col-12 p-2 d-flex align-items-center'>
                                                    <CustomTabs />
                                                </div>
                                                {
                                                    activeTab === 'Analytics' &&
                                                        <>
                                                            {
                                                                fetchingNoticeAnalytics ?
                                                                    <Spinner />
                                                                :
                                                                    <div className="col-12">
                                                                        <div className='row'>
                                                                            <div className='analyticsModal__leftDiv px-0 px-md-2 col-md-8  col-sm-12' >
                                                                                <div className='p-2'>
                                                                                    <div className='row bg-white'>
                                                                                        <div className='col-8 p-2'>
                                                                                            <div className='border border-primary row'>
                                                                                                <div className='py-2  bg-primary col-6'>
                                                                                                    <p className='smallFont' style={ { color: "white" } }>
                                                                                                        To be viewed by
                                                                                                    </p>
                                                                                                    <p className='text-white noticesCountFont'>
                                                                                                        {
                                                                                                            getNoticeAnalytics &&
                                                                                                            getNoticeAnalytics.totalAssigneeCount ? getNoticeAnalytics.totalAssigneeCount : 0
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                                <div className='py-2 col-6 '>
                                                                                                    <p className='smallFont secondaryColor'>
                                                                                                        Views
                                                                                                    </p>
                                                                                                    <p className='noticesCountFont'>
                                                                                                        {
                                                                                                            getNoticeAnalytics &&
                                                                                                            getNoticeAnalytics.totalViewsCount == null ? 0 : getNoticeAnalytics.totalViewsCount
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='col-4 px-4 d-flex justify-content-center flex-column'>
                                                                                            <p className='smallFont secondaryColor'>
                                                                                                Bookmarked by
                                                                                            </p>
                                                                                            <p className='text-primary noticesCountFont '>
                                                                                                {
                                                                                                    getNoticeAnalytics &&
                                                                                                        getNoticeAnalytics.totalBookmarkCount == null ? 0 : getNoticeAnalytics.totalBookmarkCount
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className=' analyticsModal__leftBottomDiv'>
                                                                                    <div className='row p-0'>
                                                                                        <div className='percentageView col-md-8 col-sm-12 p-0 p-md-2'>
                                                                                            <div className='bg-white '>
                                                                                                <div className='p-3 primaryColor normalBoldFont'>Notice View</div>
                                                                                                <NoticeViewGraph
                                                                                                    noticeViewGraphData={ getNoticeAnalytics.noticeViewGraphData }
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='percentageView col-md-4 col-sm-12 p-0 p-md-2'>
                                                                                            <div className='h-100 bg-white d-flex justify-content-center align-items-center'>
                                                                                                <div className='pt-4'>
                                                                                                    <div className='p-2 primaryColor normalBoldFont'>Percentage View</div>
                                                                                                    <PercentageView
                                                                                                        views={ getNoticeAnalytics.totalViewsCount }
                                                                                                        viewedBy={ getNoticeAnalytics.totalAssigneeCount }
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='analyticsModal__rightDiv col-md-4 col-sm-12 p-2'>
                                                                                <div className='row bg-white'>
                                                                                    <div className='col-md-12 col-sm-12 p-0'>
                                                                                        <div className='px-4 pt-2 primaryColor normalBoldFont'>Assignee</div>
                                                                                        <AssigneeChart
                                                                                            userRoleWiseGraphData={ getNoticeAnalytics.userRoleWiseGraphData }
                                                                                        />
                                                                                    </div>
                                                                                    <div className='my-2 col-md-12 col-sm-12 p-0'>
                                                                                        <div className='px-4 pt-2 primaryColor normalBoldFont'>Views</div>
                                                                                        <ViewsChart
                                                                                            barChartData={ getNoticeAnalytics.barChartData }
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </>
                                                }
                                                {
                                                    activeTab === 'Read History' &&
                                                        <div className='col-12 ' style={ { height: '85%' } }>
                                                            <div className='row filterHistory'>
                                                                <div>
                                                                    <FilterAltOutlined className='pointer ' onClick={ () => setShowModalFilter(true) } />
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered table-sm">
                                                                    <thead>
                                                                        <tr className='smallFont'>
                                                                            <th className='tablePadding'>Sr. No.</th>
                                                                            <th className='tablePadding'>Name</th>
                                                                            <th className='tablePadding'>Role</th>
                                                                            <th className='tablePadding'>Read Date</th>
                                                                            <th className='tablePadding'>Read Time</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            fetchingReadHistory ?
                                                                                <tr>
                                                                                    <td colSpan={5}>
                                                                                        <ButtonLoader />
                                                                                    </td>
                                                                                </tr>
                                                                            :
                                                                                Object.keys(readHistoryNoticeList).length > 0 ?
                                                                                    Object.keys(readHistoryNoticeList).map((id, index) => {
                                                                                        return <tr className='newTr'>
                                                                                            <td className='tablePadding smallFont'>{ index + 1 }.</td>
                                                                                            <td className='tablePadding smallFont'>{ readHistoryNoticeList[id].userFirstName }  { readHistoryNoticeList[id].userLastName }</td>
                                                                                            <td className='tablePadding smallFont' style={{ textTransform: 'capitalize' }}>{ readHistoryNoticeList[id].userRole }</td>
                                                                                            <td className='tablePadding smallFont'>{ readHistoryNoticeList[id].readDate }</td>
                                                                                            <td className='tablePadding smallFont'>{ readHistoryNoticeList[id].readTime }</td>
                                                                                        </tr>
                                                                                    })
                                                                                :
                                                                                    <tr>
                                                                                        <td className='tablePadding smallFont' colSpan={ 5 }>No read history details found.</td>
                                                                                    </tr>
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                }

                                                {
                                                    activeTab === 'Notification' &&
                                                        <div className='col-12 ' style={ { height: '85%' } }>
                                                            <div className="notify-again">
                                                                <p style={{ fontSize: 14 }}>You can notify unread assignees using <span style={{ fontWeight: 'bold' }}>"Notify Again"</span> button.</p>
                                                                <div class="dropdown">
                                                                    <button className="btn primary-button notify-button" data-toggle="dropdown">Notify Again</button>
                                                                    <div class="dropdown-menu notify-menu" aria-labelledby="dropdownMenuButton">
                                                                        <p style={{ fontSize: 14 }}>Are you sure you want to send notification?</p>
                                                                        <div className="notification-buttons">
                                                                            <button className="btn primary-button notify-menu-button" onClick={() => apiCallToSendNotification()}>Yes</button>
                                                                            <button className="btn outline-button notify-menu-button">No</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                sendingNotification ?
                                                                    <div className="response-message">
                                                                        <ButtonLoader />
                                                                        <p style={{ marginLeft: 3, fontSize: 14 }}>Sending Notification...</p>
                                                                    </div>
                                                                :
                                                                    responseMessage.length > 0 &&
                                                                        <div className="response-message">
                                                                            <p className={responseMessageType == 'success' ? 'alert alert-success response-msg' : responseMessageType == 'warning' ? 'alert alert-warning response-msg' : responseMessageType == 'error' && 'alert alert-danger response-msg'}>
                                                                                {responseMessage}
                                                                                <FontAwesomeIcon icon={['fas', 'times']} style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => {setResponseMessage(''); setResponseMessageType('')}} />
                                                                            </p>
                                                                        </div>
                                                            }
                                                            <div className="notification-history">
                                                                {
                                                                    fetchingNotificationHistory ?
                                                                        <ButtonLoader />
                                                                    :
                                                                        Object.keys(notificationHistory).length > 0 ?
                                                                            <Timeline> 
                                                                                {
                                                                                    Object.values(notificationHistory).map(notification => {
                                                                                        return(
                                                                                            <TimelineEvent
                                                                                                createdAt={notification.notificationDateTime}
                                                                                            >
                                                                                                <span>{notification.senderName}</span>
                                                                                            </TimelineEvent>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </Timeline>
                                                                        :
                                                                            <p style={{ color: '#818181', fontSize: 14, marginTop: 30 }}>Notification is not sent yet. Click on "Notify Again" to send notification.</p>
                                                                }
                                                            </div>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                }

                {/* sidebar for assignees */ }
                {
                    showSideBarAssignees &&
                    <Assignees
                        noticeIdStateForAssignee={ noticeIdStateForAssignee }
                        instituteDepartment={props.instituteDepartment}
                        noticeList={ noticeList }
                        setNoticeList={ setNoticeList }
                        noticeTitleStateForAssignee={ noticeTitleStateForAssignee }
                        setShowSideBarAssignees={ setShowSideBarAssignees }
                        clickedNoticeId={ clickedNoticeId }
                    /> }

                {/* sidebar for Post Notice */ }
                {
                    showSideBarPostNotice &&
                        <PostNotice
                            editMode={ editMode }
                            updateData={ updateData }
                            noticeList={ noticeList }
                            setNoticeList={ setNoticeList }
                            setPostNotice={ setShowSideBarPostNotice }
                            getMessage={getMessage}
                            instituteDepartment={props?.instituteDepartment}
                        />
                }

                {/* sidebar for Notice View */ }
                {
                    showSideBarNoticeView &&
                        <NoticeView
                            noticeViewObject={ getIndividualNoticeDetails }
                            setGetIndividualNoticeDetails={ setGetIndividualNoticeDetails }
                            setShowSideBarNoticeView={ setShowSideBarNoticeView }
                            fetchNoticeView={ fetchingIndividualNotice }
                        />
                }

                {/* modal for Warning Message if try to edit more than one row */ }
                {
                    successModalDetails.successModal &&
                    <SuccessModal
                        successModal={ successModalDetails.successModal }
                        successModalType={ successModalDetails.successModalType }
                        successMessage={ successModalDetails.successMessage }
                        closeSuccessModal={ closeSuccessModal }
                    />
                }

                {/* modal for read history filter */ }
                {
                    showModalFilter &&
                        <div className="modal fade show" id="modalContainer">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header d-flex text-center p-2" style={ { backgroundColor: "#0465ac" } }>
                                        <div className=" flex-grow-1">
                                            <p className="modal-title text-white">Filter By</p>
                                        </div>
                                        <div className="">
                                            <Close onClick={ () => setShowModalFilter(false) } style={ { color: "white", cursor: "pointer" } } />
                                        </div>
                                    </div>
                                    <div className='col-12 py-2'>
                                        <div className='normalBoldFont'>Role</div>
                                        <select
                                            className="w-100 form-control postNoticeInput"
                                            style={ { border: "0.2px solid rgba(0, 0, 0, 0.3)", outline: "none", padding: "2px" } }
                                            onChange={ (e) => {
                                                setReadHistoryFilter({
                                                    notice_id: readHistoryFilter.notice_id,
                                                    role: e.target.value,
                                                    date: readHistoryFilter.date
                                                })
                                            } }
                                            value={ readHistoryFilter.role }
                                        >
                                            <option value="">Select Role</option>
                                            <option value="student">Student</option>
                                            <option value="teaching">Teaching</option>
                                            <option value="nonteaching">Non Teaching</option>   
                                        </select>
                                        <div className='my-2'></div>
                                        <div className='normalBoldFont'>Date</div>
                                        <input
                                            className="col-12  form-control postNoticeInput"
                                            type="date"
                                            name="choose date"
                                            onChange={ (e) => {
                                                setReadHistoryFilter({
                                                    searchReadHistoryTitle: readHistoryFilter.searchReadHistoryTitle,
                                                    notice_id: readHistoryFilter.notice_id,
                                                    role: readHistoryFilter.role,
                                                    date: e.target.value,
                                                })
                                            } }
                                            value={ readHistoryFilter.date ? readHistoryFilter.date : '' }
                                        />
                                        <div className='my-2'></div>
                                        <div className="d-flex justify-content-end " style={ { height: '20%' } }>
                                            <button type="button" className="py-1 my-1 smallFont  shadow-none btn btn-primary" onClick={ () => readHistoryFilterBy() }>Apply</button>
                                            <button onClick={ () => closeFilterModal() } type="button" className="py-1 my-1 smallFont btn shadow-none btn-outline-primary">Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                }


                {/* confirmation modal for delete */ }
                {
                    deleteModalDetails.deleteModal &&
                    <DeleteModal
                        showModal={ deleteModalDetails.deleteModal }
                        visibility={ closeDeleteModal }
                        deleteKey="Notice"
                        getMessage={ deleteModalDetails.getMessage }
                        deleteComponent={ deleteNotice }
                    />
                }
            </div >
               {/* RENDER TOAST CONTAINER FOR ADD BOOKMARK  */}
               {
                // <ToastContainer />
            }
        </>
    );
}

export default Notices;